import { render } from "./EditPageCategory.vue?vue&type=template&id=dd0a788e"
import script from "./EditPageCategory.vue?vue&type=script&lang=js"
export * from "./EditPageCategory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__